import React, { forwardRef, useImperativeHandle } from 'react';
import styles from './InputPergunta.module.scss';
import LabelPergunta from '../labelPergunta/LabelPergunta';
import Radio from '../../../../../core/components/inputs/radio/Radio';
import { InputTextarea } from 'primereact/inputtextarea';
import { useFormik } from 'formik';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';

function InputPergunta(
    {
        vertical = false,
        descricao = '',
        className = '',
        disabled = false,
        placeholder = 'Descreva as Observações',
        maxLen = 200,
    },
    ref
) {
    const radioValue = useFormik({ initialValues: { radioName: null, textAreaName: '' } });

    useImperativeHandle(
        ref,
        () => ({
            radio: radioValue.values.radioName,
            text: radioValue.values.textAreaName,
            setRadioValue: (value) => radioValue.setFieldValue('radioName', value),
            setTextValue: (value) => radioValue.setFieldValue('textAreaName', value ?? ''),
        }),
        [radioValue.values]
    );

    return (
        <div className={`${styles.containerPergunta} ${className}`}>
            <LabelPergunta descricao={descricao} required />
            <div className={`${styles.containerPerguntaInputs} ${vertical ? styles.vertical : ''}`}>
                <div>
                    <Radio
                        name={'radioName'}
                        disabled={disabled}
                        label={vertical ? 'APTO' : 'SIM'}
                        value={true}
                        formik={radioValue}
                    />
                    <Radio
                        name={'radioName'}
                        disabled={disabled}
                        label={vertical ? 'INAPTO' : 'NÃO'}
                        value={false}
                        formik={radioValue}
                    />
                </div>
                <div>
                    <InputTextLengthCounter maxLen={maxLen}>
                        <InputTextarea
                            name={'textAreaName'}
                            onChange={radioValue.handleChange}
                            value={radioValue.values.textAreaName}
                            placeholder={placeholder}
                            disabled={disabled}
                        />
                    </InputTextLengthCounter>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(InputPergunta);
